import { tsValidateValue } from "@nu-art/ts-common";
export const smartDocExternalParam_ParamKey_WorkingDiagnosisId = 'workingDiagnosisId';
export const smartDocExternalParam_ParamKey_DispositionType = 'dispositionType';
export const smartDocExternalParam_ParamKeys = [smartDocExternalParam_ParamKey_WorkingDiagnosisId, smartDocExternalParam_ParamKey_DispositionType];
export const smartDocExternalParam_ParamKeys_LabelMap = {
    [smartDocExternalParam_ParamKey_WorkingDiagnosisId]: 'Working Diagnosis ID',
    [smartDocExternalParam_ParamKey_DispositionType]: 'Disposition Type',
};
export const Validator_ExternalParam_ParamKey = tsValidateValue([...smartDocExternalParam_ParamKeys]);
//# sourceMappingURL=param-key.js.map